import { InputText } from "primereact/inputtext";

interface IFieldElementSearch {
    value:string,
    placeholder:string,
    changeValue: (value: string) => void;
}

const FieldElementSearch = ({value,placeholder,changeValue}:IFieldElementSearch) => {
  return (
    <>
      <span className="p-input-icon-left" style={{ width: "100%" }}>
        <i className="pi pi-search" />
        <InputText
          value={value}
          placeholder={placeholder}
          onChange={(e) => {
            changeValue(e.target.value);
          }}
          style={{ width: "100%" }}
        />
      </span>
    </>
  );
};

export { FieldElementSearch };
